import { useSyncExternalStore } from "react";

const subscribe = () => () => {};
const getSnapshot = () => /mac/i.test(navigator.platform);
// The server cannot see the platform, so SSR assumes Mac.
const getServerSnapshot = () => true;

export const useIsMacPlatform = (): boolean => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
